import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const STATS = [
  { n: 300, pre: "$", label: "to start, at age 14", bg: "bg-[#FFB21A]" },
  { n: 800, post: "+", label: "test batches before it was right", bg: "bg-[#BDE3FA]" },
  { n: 119, label: "stores across Canada", bg: "bg-[#FF5A5F] text-white" },
  { n: 5000, post: "+", label: "sq ft facility in Nova Scotia", bg: "bg-[#1B1530] text-white" },
];

const Count = ({ n, pre = "", post = "", i }) => {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, amount: 0.15 });
  const [v, setV] = useState(n);
  useEffect(() => {
    if (!seen) return undefined;
    const c = animate(0, n, { duration: 1.6, delay: i * 0.12, ease: [0.16, 1, 0.3, 1], onUpdate: (x) => setV(Math.round(x)) });
    return () => c.stop();
  }, [seen, n, i]);
  return <span ref={ref} data-testid={`stat-value-${i}`} className="tabular-nums">{pre}{v.toLocaleString("en-CA")}{post}</span>;
};

export const StatsCounter = () => (
  <section data-testid="home-stats-section" className="py-20 lg:py-28">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
      <Reveal className="mb-10 max-w-3xl">
        <Eyebrow className="text-[#FF5A5F] mb-4">The numbers so far</Eyebrow>
        <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">From a $300 kitchen experiment to real shelves.</h2>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {STATS.map((s, i) => (
          <div key={s.label} data-testid={`stat-card-${i}`} className={`${s.bg} rounded-[28px] p-5 sm:p-8 min-h-[170px] sm:min-h-[240px] flex flex-col justify-between border border-[#1B1530]/10 transition-transform duration-500 hover:-translate-y-1.5`}>
            <span className="font-display text-5xl sm:text-7xl xl:text-8xl leading-none"><Count {...s} i={i} /></span>
            <span className="font-semibold text-sm sm:text-base">{s.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
